import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // 1. Импортируем BrowserRouter
import './index.css';
import App from './App';
// ... возможно, другой код ...

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter> {/* 2. Оборачиваем App */}
            <App />
        </BrowserRouter>
    </React.StrictMode>
);